import React, { useEffect } from "react";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { FiFacebook } from "react-icons/fi";
import { PiTiktokLogo } from "react-icons/pi";
import { IoLogoInstagram } from "react-icons/io5";
import { FaEarthAmericas } from "react-icons/fa6";
import { SlSocialLinkedin } from "react-icons/sl";
import { TbDeviceLandlinePhone } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlinePhone, MdOutlineMailOutline } from "react-icons/md";
import { LuEarth } from "react-icons/lu";
import {
  fetchLlmsData,
  fetchImsData,
  fetchOfficeData,
} from "../redux/slicer/itServicesSlice";
import Logo from "../assets/sab.png";

const Footer = () => {
  const dispatch = useDispatch();
  const { data: itServicesData } = useSelector((state) => state.services.llms);
  const { data: imsData } = useSelector((state) => state.services.ims);

  useEffect(() => {
    dispatch(fetchLlmsData());
    dispatch(fetchImsData());
    dispatch(fetchOfficeData());
  }, [dispatch]);

  return (
    <footer className="bg-Footer-color text-white">
      <div className="container mx-auto px-4 sm:px-8 py-12">
        {/* Layout: Navigation and Map */}
        <div className="flex flex-col lg:flex-row lg:justify-between gap-12">
          {/* Navigation Section */}
          <div className="flex-1">
            <div className="grid gap-8 text-center sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 lg:text-left">
              {/* Logo and Social Media Links */}
              <div>
                <img src={Logo} alt="logo" className="h-30 mx-auto md:mx-0" />
                <p className="mt-4 font-inter">
                  Expand the Boundaries of Quality Education with world-class
                  standards.
                </p>
                <div className="flex justify-center md:justify-start gap-4 mt-6 py-6 md:justify-center">
                  <a
                    href="https://www.instagram.com/casrilankasab/?igsh=MW9naWludWN0ZXZ5aw%3D%3D#"
                    className="hover:text-primary-color"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IoLogoInstagram size={24} />
                  </a>
                  <a
                    href="https://web.facebook.com/sabcasl"
                    className="hover:text-primary-color"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FiFacebook size={24} />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/ca-sri-lanka-school-of-accounting-business/?viewAsMember=true"
                    className="hover:text-primary-color"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SlSocialLinkedin size={24} />
                  </a>
                  <a
                    href="https://www.tiktok.com/@sab.campus.ca.srilanka?_t=ZS-8tKFvOITMJd&_r=1"
                    className="hover:text-primary-color"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PiTiktokLogo size={24} />
                  </a>
                </div>
              </div>

              {/* Navigation and Useful Links */}
              <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-2 lg:justify-center text-left">
                {/* Navigation Links */}
                <div>
                  <h3 className="text-lg md:text-xl md:text-left sm:text-left font-bold mb-4">
                    Navigation
                  </h3>
                  <ul className="space-y-2 md:text-left">
                    <li>
                      <a href="/" className="hover:underline">
                        Home
                      </a>
                    </li>
                    <li>
                      <a href="/aluminai" className="hover:underline">
                        Alumni
                      </a>
                    </li>
                    <li>
                      <a href="/acadamics" className="hover:underline">
                        Academics
                      </a>
                    </li>
                    <li>
                      <a
                        href="/research-and-student-life"
                        className="hover:underline"
                      >
                        Research & Publications
                      </a>
                    </li>
                    <li>
                      <a href="/student-life" className="hover:underline">
                        Student Life
                      </a>
                    </li>
                    <li>
                      <a href="/gallery-and-news" className="hover:underline">
                        Gallery & News
                      </a>
                    </li>
                    <li>
                      <a href="/it-services" className="hover:underline">
                        Student Support
                      </a>
                    </li>
                    {/* <li>
                      <a href="/careers" className="hover:underline">
                        Careers
                      </a>
                    </li> */}
                  </ul>
                </div>

                {/* Useful Links */}
                <div>
                  <h3 className="text-lg md:text-xl font-bold mb-4 md:text-left">
                    Useful Links
                  </h3>
                  <ul className="space-y-4 text-sm">
                    {/* Mapping LMS Data */}
                    {itServicesData.map((service, index) => (
                      <li
                        key={service.id || index}
                        className="flex items-center cursor-pointer hover:underline "
                        onClick={() => window.open(service.url, "_blank")}
                      >
                        <FaRegArrowAltCircleRight className="mr-2 text-lg" />
                        {service.name || "LMS"}
                      </li>
                    ))}

                    {/* Mapping Smart Library Data */}
                    {imsData.map((portal, index) => (
                      <li
                        key={portal.id || index}
                        className="flex items-center cursor-pointer hover:underline mt-4"
                        onClick={() => window.open(portal.url, "_blank")}
                      >
                        <FaRegArrowAltCircleRight className="mr-2 text-lg" />
                        {portal.name || "IMS"}
                      </li>
                    ))}

                    <li className="flex items-center">
                      <FaRegArrowAltCircleRight className="mr-2 text-lg" />
                      <a href="/contact-us" className="hover:underline">
                        Contact Us
                      </a>
                    </li>
                    <li className="flex items-center">
                      <FaRegArrowAltCircleRight className="mr-2 text-lg" />
                      <a href="/about-us" className="hover:underline">
                        About Us
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="flex-2 xl:hidden lg:block">
                  <h3 className="text-lg font-bold mb-4  font-inter text-left">
                    Contact Details
                  </h3>

                  {/* <p className=" font-inter text-left">SAB Campus.</p> */}
                  {/* <p> 411, Galle Main Rd, Colombo 04,</p> */}
                  {/* <p className=" font-inter text-left"> 411, Galle Main Rd,</p>
                  <p className=" font-inter text-left">Colombo 04,</p>
                  <p className=" font-inter text-left">Sri Lanka.</p> */}
                  <ul className="space-y-2 mt-4 font-inter text-left">
                    <li>
                      <a>
                        {" "}
                        SAB Campus.411, Galle Rd, <br /> Colombo 04,{" "}
                      </a>
                    </li>
                    <li>
                      <a>
                        {" "}
                        316, Galle Road, <br /> Colombo 04,{" "}
                      </a>
                    </li>
                    <li>
                      Registered office:{" "}
                      <a>
                        30A,
                        <br /> Malalasekara Mawatha, <br /> Colombo-07
                      </a>
                    </li>

                    <li>
                      <TbDeviceLandlinePhone className="inline-block mr-2" />{" "}
                      <a href="tel:+94114486400">+94 112 807 407</a>
                    </li>
                    <li>
                      <MdOutlinePhone className="inline-block text-lg mr-2" />{" "}
                      <a href="tel:+94112413500">+94 71 0235 263</a>
                    </li>
                    {/* <li>
    Fax: <a href="fax:+94112413505">+94 112 101 044</a>
</li> */}
                    <li>
                      <MdOutlineMailOutline className="inline-block mr-2" />
                      <a
                        href="mailto:sab@casrilanka.org"
                        className="text-blue-300 font-inter"
                      >
                        sab@casrilanka.org
                      </a>
                      <br />
                      {/* <a
        href="https://www.casrilanka.com/casl/index.php?option=com_content&view=article&id=786&Itemid=302"
        className="text-blue-300  font-inter"
    >
        casrilanka.com
    </a> */}
                    </li>

                    <li>
                      <LuEarth className="inline-block mr-2" />
                      <a
                        href="https://www.casrilanka.com/casl/index.php?option=com_content&view=article&id=786&Itemid=302"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-300  font-inter"
                      >
                        casrilanka.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Details Section */}
          <div className="hidden lg:block">
            <h3 className="text-lg font-bold mb-4  font-inter text-left">
              Contact Details
            </h3>

            {/* <p className=" font-inter text-left">SAB Campus.</p> */}
            {/* <p> 411, Galle Main Rd, Colombo 04,</p> */}
            {/* <p className=" font-inter text-left"> 411, Galle Rd,</p>
            <p className=" font-inter text-left">Colombo 04,</p>
            <p className=" font-inter text-left">Sri Lanka.</p> */}
            <ul className="space-y-2 mt-4 text-left">
              <li>
                <a>
                  {" "}
                  SAB Campus.411, Galle Rd, <br /> Colombo 04,{" "}
                </a>
              </li>
              <li>
                <a>
                  {" "}
                  316, Galle Road, <br /> Colombo 04,{" "}
                </a>
              </li>
              <li>
                Registered office:{" "}
                <a>
                  30A,
                  <br /> Malalasekara Mawatha, <br /> Colombo-07
                </a>
              </li>

              <li>
                <TbDeviceLandlinePhone className="inline-block mr-2" />{" "}
                <a href="tel:+94114486400">+94 112 807 407</a>
              </li>
              <li>
                <MdOutlinePhone className="inline-block text-lg mr-2" />{" "}
                <a href="tel:+94112413500">+94 71 0235 263</a>
              </li>
              {/* <li>
    Fax: <a href="fax:+94112413505">+94 112 101 044</a>
</li> */}
              <li>
                <MdOutlineMailOutline className="inline-block mr-2" />
                <a
                  href="mailto:sab@casrilanka.org"
                  className="text-blue-300 font-inter"
                >
                  sab@casrilanka.org
                </a>
                <br />
                {/* <a
        href="https://www.casrilanka.com/casl/index.php?option=com_content&view=article&id=786&Itemid=302"
        className="text-blue-300  font-inter"
    >
        casrilanka.com
    </a> */}
              </li>

              <li>
                <LuEarth className="inline-block mr-2" />
                <a
                  href="https://www.casrilanka.com/casl/index.php?option=com_content&view=article&id=786&Itemid=302"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-300  font-inter"
                >
                  casrilanka.com
                </a>
              </li>
            </ul>
          </div>

          {/* Google Map Section */}
          <div className="flex-1 ">
            <iframe
              src="https://maps.google.com/maps?width=700&amp;height=800&amp;hl=en&amp;q=SAB%20Campus%20of%20CA%20Sri%20Lanka+(SAB%20Campus)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              className="w-full h-72 rounded"
              title="Google Map"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-white py-4">
        <p className="text-center text-sm font-inter">
          CA Sri Lanka | SAB Campus 2025 All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
